import React, { useContext } from 'react';
import classNames from 'classnames';
import { Outlet } from 'react-router';
import settingRoutes from './routes';
import DataRoomSubrouterNavigation from '../../components/DataRoomSubrouterNavigation';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';

type SettingsRouterProps = {
  className?: string;
};

const SettingsRouter: React.FC<SettingsRouterProps> = (props) => {
  const { className } = props;

  const {
    dataRoom: { name },
  } = useContext(DataRoomContext);
  const { t } = useTranslation();

  const classes = classNames('res-dr-settings-router', className);

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('setUpDataRoom')} - ${name}`} />
      <DataRoomSubrouterNavigation
        routes={settingRoutes.filter(({ labelString }) => !!labelString)}
      />
      <Outlet />
    </div>
  );
};

export default SettingsRouter;
